import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';
import merge from 'deepmerge';
import modalStyles from '../../constants/modalStyles';
import ModalFooter from '../ModalFooter';
import { BUTTON_VARIANTS } from '../Button/Button';
import Logger from '../../utils/logger';
import './Modal.scss';

const Modal = ({
  children,
  hasFooter,
  hasSecondaryCTA,
  primaryCTAText,
  primaryCTAVariant,
  primaryCTAAdditionalProps,
  secondaryCTAAdditionalProps,
  secondaryCTAText,
  secondaryCTAVariant,
  styles,
  ...props
}) => (
  <ReactModal style={merge(modalStyles, styles)} {...props}>
    <div className="ModalBody">
      {children}
    </div>

    {hasFooter
      && (
      <ModalFooter
        primaryCTAText={primaryCTAText}
        primaryCTAVariant={primaryCTAVariant}
        secondaryCTAText={secondaryCTAText}
        secondaryCTAVariant={secondaryCTAVariant}
        hasSecondaryCTA={hasSecondaryCTA}
        primaryCTAAdditionalProps={primaryCTAAdditionalProps}
        secondaryCTAAdditionalProps={secondaryCTAAdditionalProps}
      />
      )}
  </ReactModal>
);

// this identifier is true of widget and consumer
try {
  ReactModal.setAppElement('#page-wrapper');
} catch (e) {
  // test DOMs don't include #page-wrapper
  const isMissingPageWrapperInTest = process.env.NODE_ENV === 'test' && e?.message?.includes('#page-wrapper');
  if (!isMissingPageWrapperInTest) {
    Logger.error('e', e);
  }
}

Modal.displayName = 'Modal';

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  hasFooter: PropTypes.bool.isRequired,
  hasSecondaryCTA: PropTypes.bool.isRequired,
  primaryCTAAdditionalProps: PropTypes.shape({}),
  primaryCTAText: PropTypes.string.isRequired,
  primaryCTAVariant: BUTTON_VARIANTS,
  secondaryCTAAdditionalProps: PropTypes.shape({}),
  secondaryCTAText: PropTypes.string,
  secondaryCTAVariant: BUTTON_VARIANTS,
  styles: PropTypes.shape({
    overlay: PropTypes.shape({}),
    content: PropTypes.shape({}),
  }),
};

Modal.defaultProps = {
  primaryCTAAdditionalProps: {},
  primaryCTAVariant: undefined,
  secondaryCTAAdditionalProps: {},
  secondaryCTAText: undefined,
  secondaryCTAVariant: undefined,
  styles: {},
};

export default Modal;
